window.Configs = {
    // User defined data
    library: {},
    filters: {},
    cards: {},

    // Filter box data, checkbox and range
    filter_list: {},

    // Card data as component
    component_cards: {},
}